import type { InfoTopBannerType } from "@/features/top-banners/api/get-info-top-banner";

const getStartTime = (banner: InfoTopBannerType) =>
  banner.start_at ? Date.parse(banner.start_at) : 0;

export const getActiveInfoBanners = (
  banners: InfoTopBannerType[],
  now: number,
) =>
  banners
    .filter(
      (banner) =>
        !!banner.text?.trim() &&
        getStartTime(banner) <= now &&
        (!banner.end_at || now < Date.parse(banner.end_at)),
    )
    .sort((a, b) => getStartTime(b) - getStartTime(a));
